export const MAXDBLENGTHS = {
  //Common
  STREET: 100,
  CITY: 100,
  ZIP: 25,
  PHONE: 20,
  COUNTY: 100,
  COUNTRY: 100,
  STATE: 100,

  //Places
  PLACE_NAME: 140,
  CID: 24,
  YARD_NAME: 100,
  SITE_DETAIL: 1000,
  PLACE_COMMENTS: 140,
  YARD_GATE_NOTE: 60,

  //Route
  ROUTE_NAME_LENGTH: 50,
};
